module.exports = __webpack_public_path__ + "static/media/client-logo-10.0bff898a.jpg";